<template>

  <RiepilogoProvvigioni />
 
</template>

<script>
import RiepilogoProvvigioni from '../components/pratiche/RiepilogoProvvigioni.vue'

export default {
  pageName: '',
  components: {
    RiepilogoProvvigioni

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
